"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeResult = exports.deserializeResult = exports.deserializePartialResult = void 0;
const deserializePartialResult = (result) => {
    var _a;
    return ({
        typebotId: result.typebot_id,
        isCompleted: (_a = result.is_completed) !== null && _a !== void 0 ? _a : false,
        createdDate: result.created_date ? new Date(result.created_date) : undefined,
        modifiedDate: result.modified_date
            ? new Date(result.modified_date)
            : undefined,
        data: deserializeData(result.data),
        variables: deserializeVariables(result.variables),
    });
};
exports.deserializePartialResult = deserializePartialResult;
const deserializeResult = (result) => {
    var _a;
    return ({
        typebotId: result.typebot_id,
        isCompleted: (_a = result.is_completed) !== null && _a !== void 0 ? _a : false,
        createdDate: new Date(result.created_date),
        modifiedDate: new Date(result.modified_date),
        data: deserializeData(result.data),
        variables: deserializeVariables(result.variables),
        id: result.id,
        timeSpent: result.time_spent,
    });
};
exports.deserializeResult = deserializeResult;
const deserializeData = (data) => {
    if (Array.isArray(data) && data.every((entry) => "questionId" in entry))
        return data;
};
const deserializeVariables = (variables) => {
    if (Array.isArray(variables) &&
        variables.every((entry) => "name" in entry && "value" in entry))
        return variables;
};
const serializeResult = (result) => ({
    created_date: result.createdDate,
    modified_date: result.modifiedDate,
    variables: result.variables,
    id: result.id,
    is_completed: result.isCompleted,
    typebot_id: result.typebotId,
    data: result.data,
});
exports.serializeResult = serializeResult;
//# sourceMappingURL=results.js.map